export default "__VITE_ASSET__CUwjxMuw__"